var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlideTrendFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3332 2.5H1.6665V4.16667H2.9165V13.3333C2.9165 13.7936 3.2896 14.1667 3.74984 14.1667H6.64034L3.7832 17.5H5.97834L8.83546 14.1667H11.1642L14.0213 17.5H16.2165L13.3593 14.1667H16.2498C16.7101 14.1667 17.0832 13.7936 17.0832 13.3333V4.16667H18.3332V2.5ZM10.6249 10.9701L14.7558 6.83921L13.5773 5.66071L10.6249 8.61312L8.74992 6.73812L5.66063 9.82737L6.83917 11.0059L8.74992 9.09513L10.6249 10.9701Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideTrendFill);
export default __webpack_public_path__ + "static/media/slide_trend_fill.771ef2f53922ebe1581752fb1af0af64.svg";
export { ForwardRef as ReactComponent };